<template>
    <svg width="32" height="24" viewBox="0 0 32 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M12.5657 23.1219C11.7605 23.1237 10.9792 22.8506 10.3509 22.3493L1.76638 15.4817C0.240095 14.2592 -0.00542343 12.029 1.21705 10.5026C2.43952 8.97615 4.6697 8.73079 6.19615 9.95326L12.3083 14.8465L25.5115 1.6434C26.8954 0.259491 29.1411 0.259491 30.5248 1.6434C31.9086 3.02731 31.9088 5.27302 30.5248 6.65677L15.0726 22.109C14.4046 22.7648 13.5033 23.1288 12.5657 23.1219Z" fill="#64AD07"/>
    </svg>
</template>

